"use strict";
(function () {

    function LanguageTool() {
    }

    LanguageTool.prototype.setPageLanguage = function () {
        var locale = getLocaleFromUrl();
        if(!locale) {
            locale = getLocaleFromCookie();
        }
        if (!locale && this.ipIsInternational()){
            locale = 'en-us';
        }
        if (!locale) {
            locale = getLocaleFromBrowser();
        }
        if (!locale) {
            locale = 'en-us';
        }
        this.setLocale(locale);

        function getLocaleFromUrl() {
            var service;
            var searchStr = decodeURIComponent(decodeURIComponent(window.location.search.substring(1)));
            var params = searchStr.split("&");
            for (var index = 0; index < params.length; index++) {
                var key = params[index].substring(0, params[index].indexOf("="));
                if (key === "locale")
                {
                    var value = params[index].substring(params[index].indexOf("=") + 1);
                    return decodeURIComponent(value);
                }
                if(key === "service")
                {
                    service = params[index].substring(params[index].indexOf("=") + 1);
                }
            }
            return getLocaleFromService(service);
        }

        function  getLocaleFromService(service)
        {
            if(service) {
                var serviceParam = service.split("?");
                if(serviceParam.length>1)
                {
                    var serviceParams = serviceParam[1].split("&");
                    for (var index = 0; index < serviceParams.length; index++) {
                        var key = serviceParams[index].substring(0, serviceParams[index].indexOf("="));
                        if (key === "locale")
                        {
                            var value = serviceParams[index].substring(serviceParams[index].indexOf("=") + 1);
                            return decodeURIComponent(value);
                        }
                    }
                }
            }
            return undefined;
        }

        //w3c recommend
        function getLocaleFromCookie() {
            var cookieName = "locale";
            if (document.cookie.length > 0) {
                var c_start = document.cookie.indexOf(cookieName + "=");
                if (c_start != -1) {
                    c_start = c_start + cookieName.length + 1;
                    var c_end = document.cookie.indexOf(";", c_start);
                    if (c_end == -1) c_end = document.cookie.length;
                    return decodeURIComponent(document.cookie.substring(c_start, c_end));
                }
            }
            return undefined;
        }

        function getLocaleFromBrowser() {
            var language2localeMap = {
                'zh' : 'zh-cn',
                'en' : 'en-us',
                'es' : 'es-us',
                'pt' : 'pt-br',
                'fr' : 'fr-fr'
            }
            var language = (navigator.browserLanguage || navigator.language).toLowerCase();
            locale = language2localeMap[language.substring(0,2)];
            return locale;
        }
    };

    LanguageTool.prototype.setLocale = function (locale) {
        window.language = locale;
        this.updateLocaleInCookie(locale);
        var tinyLang =locale.substring(0,2);
        document.cookie = "tiny_language="+tinyLang + ";secure";
    };

    LanguageTool.prototype.getLocale = function () {
        return window.language;
    };

    LanguageTool.prototype.addCssToPage = function (href) {
        var head = document.getElementsByTagName("head")[0];
        var cssLink = document.createElement("link");
        cssLink.type = "text/css";
        cssLink.rel = "stylesheet";
        cssLink.href = href;
        head.appendChild(cssLink);
    };

    LanguageTool.prototype.updateLocaleInCookie = function (value) {
        if(this.getLocaleFromCookie() != undefined)
        {
            this.delLocaleFromCookie();
        }

        var cookieStr = "locale=" + encodeURIComponent(value);
        var expiresTime = 30 * 24 * 3600 * 1000;
        var date = new Date();
        date.setTime(date.getTime() + expiresTime);
        cookieStr += ";domain=" + this.getParentDomain() + ";Path=/;expires=" + date.toUTCString() + ";secure";

        document.cookie = cookieStr;
    };

    LanguageTool.prototype.getLocaleFromCookie = function () {
        var cookieStr = document.cookie;
        var cookieArray = cookieStr.split(";");

        for (var i = 0; i < cookieArray.length; i++)
        {
            var arr= this.iamTrim(cookieArray[i].toString()).split("=");
            if (arr[0] === "locale")
            {
                return decodeURIComponent(arr[1]);
            }
        }
        return undefined;
    };

    LanguageTool.prototype.delLocaleFromCookie = function () {
        var date = new Date();
        date.setTime(date.getTime() - 10000);
        document.cookie = "locale=v;domain="+ this.getParentDomain() +";Path=/;expires=" + date.toUTCString();
    };

    LanguageTool.prototype.iamTrim = function (text) {
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        return text == null ? "" : ( text + "" ).replace( rtrim, "" );
    };

    LanguageTool.prototype.isHongKongDomain = function () {
        return window.location.hostname=="auth-intl.huaweicloud.com";
    }
    //如果hostname是IP，则取hostname，否则取域名中auth的上一级域名（保留最前边的点）
    LanguageTool.prototype.getParentDomain = function(){
        var reg =  /^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        var hostName = window.location.hostname;
        return reg.test(hostName) ? hostName : hostName.substr(hostName.indexOf('.'));
    };

    // 通过cookie判断是否为海外IP
    LanguageTool.prototype.ipIsInternational = function () {
        var cookieStr = document.cookie;
        var cookieArray = cookieStr.split(";");
        for (var i = 0; i < cookieArray.length; i++) {
            var arr= this.iamTrim(cookieArray[i].toString()).split("=");
            if (arr[0] === "Site") {
                // mainland国内IP intl国际IP
                return decodeURIComponent(arr[1]) === "intl";
            }
        }
        return false;
    }

    if (!window.IAM) {
        window.IAM = {};
    }

    window.IAM.LanguageTool = LanguageTool;
})();




// WEBPACK FOOTER //
// ./public/base/pre/langTool.js